<template>
  <div class="pluck-sharing"
        v-show="code">
    <h3 class="title"
       v-html="$t('journey.pluck.sharing.title')"></h3>

    <p class="desc"
       v-html="$t('journey.pluck.sharing.description')"></p>

    <p class="user-id">
      ‘ {{ userData.userId }} ’
    </p>

    <p class="url">
      <input type="text"
             :value="`${url}${code}`" />
      <pre>{{ url }}{{ code }}</pre>
      <transition name="fade">
        <div class="copy-toast"
             v-if="showToastLayer">
          <span>{{ $t('common.copied') }}</span>
          <i class="icon icon--check-green-size16"></i>
        </div>
      </transition>
    </p>

    <ui-button class="btn-copy"
               :buttonType="'reset'"
               @click="onCopy">
      {{ $t('common.copy') }}
    </ui-button>

    <i class="close-layer icon icon--close-size16" @click="$emit('onClose')"></i>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPluckShare } from '@/api/pluck'

import UiButton from '@/components/ui/UiButton'

export default {
  name: 'PluckSharing',
  components: {
    UiButton
  },
  props: {
    treeId: {
      type: String
    }
  },
  computed: {
    ...mapState([
      'userData',
      'journeyPeriod',
      'journeyOptions'
    ]),

    options () {
      return {
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        device: this.journeyOptions.device,
        exist: this.journeyOptions.exist,
        matchType: this.journeyOptions.matchType,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        sid: this.journeyOptions.sid,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        treeId: this.treeId
      }
    }
  },
  created () {
    this.url = `${location.protocol}//${location.host}${location.pathname}?sid=${this.journeyOptions.sid}`
    if (this.journeyOptions.subSid) {
      this.url = this.url + `&subSid=${this.journeyOptions.subSid}`
    }
    if (this.treeId && this.treeId !== 'current') {
      this.getCode()
    }
  },
  methods: {
    getCode () {
      getPluckShare({ data: this.options }, true).then(response => {
        this.code = '&pluck=' + response.code
      })
    },
    onCopy () {
      let range = document.createRange()
      range.setStartBefore(document.querySelector('pre'))
      range.setEndAfter(document.querySelector('pre'))
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      document.execCommand('copy')
      this.showToastLayer = true
      setTimeout(() => {
        this.showToastLayer = false
      }, 5000)
    }
  },
  data () {
    return {
      url: '',
      code: '',
      showToastLayer: false
    }
  }
}
</script>

<style lang="scss" scoped>
.pluck-sharing {
  text-align: center;

  .close-layer {
    position: absolute;
    margin: 12px;
    top: 0;
    right: 0;
    background-position: center;
  }

  .title {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: center;
    color: #444;
    margin: 50px 30px 12px;
  }

  .desc {
    margin: 12px 30px;
    font-size: 14px;
    line-height: 1.5;
    color: #555555;
  }

  .user-id {
    margin: 25px 30px;
    font-size: 20px;
    line-height: 1.05;
    color: #0e90a5;
  }

  .url {
    position: relative;
    margin: 25px 30px 0;

    pre {
      position: absolute;
      top: -10px;
      left: -10000px;
      overflow: hidden;
      opacity: 0;
    }

    input {
      width: calc(100% - 11px);
      padding: 0 0 0 11px;
      height: 36px;
      line-height: 36px;
      border-radius: 6px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      color: #2f2f2f;
      font-size: 14px;
    }

    .copy-toast {
      display: inline-block;
      border-radius: 6px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
      background-color: rgba(0,0,0,0.85);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      line-height: 32px;
      padding-left: 10px;
      padding-right: 42px;

      span {
        font-size: 13px;
        font-weight: 500;
        color: #57ab00;
      }

      i {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
      }

      &.fade-enter-active,
      &.fade-leave-active {
        opacity: 1;
        transition: opacity 0.2s ease;
      }

      &.fade-enter,
      &.fade-leave-to{
        opacity: 0;
      }
    }
  }

  .btn-copy {
    margin-top: 44px;
    width: 90px;
  }
}
</style>
